import React from 'react'
import './style.css'
import hero1 from '../../images/slider/shape.jpg'
import heroMobile from '../../images/home/home_hero_banner.jpg'
import VideoModal from '../ModalVideo'
import { Link } from 'react-router-dom'

const Hero = (props) => {

  return (
		<section className="hero hero-style-2">
			<div className="hero-slider">
				<div className="slide">
					<div className="container">
						<div className="row">
							<div className="col col-lg-6 slide-caption">
								<div className="slide-title">
									<h2>Silence is not empty here</h2>
								</div>
								<div className="slide-subtitle">
									<p>It is alive, expressive, and eloquent.</p>
								</div>
								<div className="btns">
									<Link to="/about" className="theme-btn">
										Learn More
									</Link>
									<ul>
										<li className="video-holder">
											<VideoModal videoId={"F_T2HmtN4cs"} />
										</li>
										<li className="video-text">Watch Our Video</li>
									</ul>
								</div>
								<div className="hero-mobile-image">
									<img src={heroMobile} alt="Nirbaak" />
								</div>
							</div>
						</div>
					</div>
					<div className="right-vec"></div>
				</div>
			</div>
			<div className="hero-shape">
				<img src={hero1} alt="" />
			</div>
		</section>
	);
}

export default Hero;